export default "__VITE_ASSET__yyZh7Smf__"